import client from "../../client/client";

class FormStudioService {
	getAllViews({ name = "" }, cancelToken) {
		return client.get("/backoffice/page-template/pages/all", { params: { name }, config: { cancelToken } });
	}

	createView({ name, layout, fieldIds, description = "" }, cancelToken) {
		return client.post("/backoffice/page-template/pages", {
			payload: { name, layout, fieldIds, description },
			config: { cancelToken },
		});
	}

	getView({ pageId }, cancelToken) {
		return client.get(`/backoffice/page-template/pages/${pageId}`, { config: { cancelToken } });
	}

	duplicateView({ pageId }, cancelToken) {
		return client.post(`/backoffice/page-template/pages/${pageId}/duplicate`, { config: { cancelToken } });
	}

	deleteView({ pageId }, cancelToken) {
		return client.delete(`/backoffice/page-template/pages/${pageId}`, { config: { cancelToken } });
	}

	updateView({ pageId }, { name, layout, fieldIds, description = "" }, cancelToken) {
		return client.patch(`/backoffice/page-template/pages/${pageId}`, {
			payload: { name, layout, fieldIds, description },
			config: { cancelToken },
		});
	}

	createCriteria(payload, cancelToken) {
		return client.post("/backoffice/page-template/fields", {
			payload,
			config: { cancelToken },
		});
	}

	getCriteria({ fieldId }, cancelToken) {
		return client.get(`/backoffice/page-template/fields/${fieldId}`, {
			config: { cancelToken },
		});
	}

	deleteCriteria({ fieldId }, cancelToken) {
		return client.delete(`/backoffice/page-template/fields/${fieldId}`, {
			config: { cancelToken },
		});
	}

	updateCriteria({ fieldId }, payload, cancelToken) {
		return client.patch(`/backoffice/page-template/fields/${fieldId}`, {
			payload,
			config: { cancelToken },
		});
	}

	duplicateCriteria({ fieldId }, cancelToken) {
		return client.post(`/backoffice/page-template/fields/${fieldId}/duplicate`, {
			config: { cancelToken },
		});
	}

	getAllCriteria({ name = "" }, cancelToken) {
		return client.get("/backoffice/page-template/fields/all", {
			params: { name },
			config: { cancelToken },
		});
	}

	getViewProjects({ pageId }, cancelToken) {
		return client.get(`/backoffice/page-template/pages/${pageId}/projects`, {
			config: { cancelToken },
		});
	}

	updateViewProjects({ pageId }, { toAdd, toRemove }, cancelToken) {
		return client.put(`/backoffice/page-template/pages/${pageId}/projects`, {
			payload: { toAdd, toRemove },
			config: { cancelToken },
		});
	}

	getViewCompanies({ pageId }, cancelToken) {
		return client.get(`/backoffice/page-template/pages/${pageId}/companies`, {
			config: { cancelToken },
		});
	}

	updateViewCompanies({ pageId }, { toAdd, toRemove }, cancelToken) {
		return client.put(`/backoffice/page-template/pages/${pageId}/companies`, {
			payload: { toAdd, toRemove },
			config: { cancelToken },
		});
	}

	getViewCriteria({ pageId }, cancelToken) {
		return client.get(`/backoffice/page-template/pages/${pageId}/fields`, {
			config: { cancelToken },
		});
	}
}
export default new FormStudioService();
